import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PatientTabsContext } from '../../../lib/contexts';
import useMetric from '../../../lib/hooks/useMetric';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import PatientKeyNutrientsBox from './PatientKeyNutrientsBox';
import PatientAddToListBox from './PatientAddToListBox';

const useStyles = makeStyles((theme) => ({
  patientChartCard: {
    ...theme.globalClasses.patientChartCard,
    ...theme.globalClasses.adminTableWrapper,
    marginTop: 16,
  },
  icon: theme.globalClasses.adminTableIcon,
  topBar: {
    marginBottom: 16,
  },
  tableHead: theme.globalClasses.adminTableHead,
  tableRow: theme.globalClasses.adminTableRow,
  graphContainer: {
    // Add any existing styles for the graph container
  },
  '@media print': {
    graphContainer: {
      overflow: 'visible',
      transform: 'scale(0.50)',
      transformOrigin: 'top left',
      width: '100%',
      height: 'auto',
      position: 'relative',
    },
    // graphContainer: {
    //   overflow: 'visible',
    //   transform: 'none',
    //   width: 'auto',
    //   height: 'auto',
    // },
  },
  link: theme.globalClasses.link,
}));

const PatientSummaryBox = ({ summary, setSetSubtab }) => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    state: { currentTab },
    actions: { goListTab },
  } = useContext(PatientTabsContext);

  const { isLoading, data } = useMetric('latest_assessments', currentTab.id);

  const { isLoading: isLoadingPriorities, data: prioritiesData } = useMetric('priorities', currentTab.id);

  const {
    isLoading: patientListsIsLoading,
    data: patientListsData,
    refetch: refetchPatientLists,
  } = useMetric('patient_lists', currentTab.id);

  return (
    <Grid
      item
      xs={12}
      className={`patient-summary-overview-box`}
      id="patient-summary-overview-box"
    >
      <Paper className={classes.patientChartCard}>
        {isLoading || isLoadingPriorities ? (
          <AdminProgressBar />
        ) : (
          <>
            {/* Patient Lists */}
            {!patientListsIsLoading && patientListsData && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                  mb: 3,
                }}
              >
                <PatientAddToListBox
                  data={patientListsData?.metric?.value}
                  goListTab={goListTab}
                  currentTab={currentTab}
                  refetch={refetchPatientLists}
                />
              </Box>
            )}
            {data && prioritiesData.metric && prioritiesData.metric.value && (
              <PatientKeyNutrientsBox
                summary={true}
                setSetSubtab={setSetSubtab}
              />
            )}
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default PatientSummaryBox;
